.a6{align-items:stretch;}